<template>
  <ValidationProvider v-slot="{ errors }" :name="`'${label}'`" :rules="rules" :vid="vid">
    <v-checkbox
        v-model="innerValue"
        :readonly="readonly"
        :prepend-icon="prependIcon"
        :error-messages="errors"
        :label="label" />
  </ValidationProvider>
</template>

<script>
  export default {
    props: {
      value: {
        type: Boolean,
        default: null
      },
      rules: [String, Object],
      prependIcon: {
        type: String,
        default: ''
      },
      label: {
        type: String,
        default: ''
      },
      readonly: {
        type: Boolean,
        default: false
      },
      vid: {
        type: String,
        default: null
      }
    },
    data () {
      return {
        innerValue: null
      }
    },
    watch: {
      value: {
        immediate: true,
        handler (newVal) {
          if (newVal !== this.innerValue) {
            this.innerValue = newVal
          }
        }
      },
      innerValue (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    }
  }
</script>
